import React from 'react';
import { useNavigate } from 'react-router-dom';

const WizardLauncher: React.FC = () => {
  const navigate = useNavigate();

  const handleOpenWizard = () => {
    navigate('/configurar-moodle');
  };

  return (
    <button 
      className="btn btn-primary wizard-launcher"
      onClick={handleOpenWizard}
    >
      🚀 Configurar Mi Moodle
    </button>
  );
};

export default WizardLauncher;